import TrainingSearch from "../models/TrainingSearch";
import FileVM from "../viewmodels/FileVM";
import api, { ApiResponse } from "./api";
import CurrentUser from "./CurrentUser";

export interface AddDeleteFilesResponse {
    success: boolean;
    returnArray: any[];
}

export default {
    async addDeleteFiles(allFiles: FileVM[], linkTable: string, linkTableID: number): Promise<AddDeleteFilesResponse> {
        var success = true;

        for (var i = 0; i < allFiles.length; i++) {
            if (allFiles[i].ID == 0 && !allFiles[i].IsDeleted && allFiles[i].File) {
                let uploadFileResponse = await api.postWithFiles<any>('File/UploadFile?userToken=' + CurrentUser.currentUserToken() + '&linkTable=' + linkTable + '&linkTableId=' + linkTableID, allFiles[i].File);

                if (uploadFileResponse.ok) {
                    // Re-add files now with an ID
                    allFiles[i] = uploadFileResponse.data!;
                }
                else {
                    success = false;
                }
            }
            else if (allFiles[i].ID != 0 && allFiles[i].IsDeleted) {
                await api.delete('File/DeleteFile?userToken=' + CurrentUser.currentUserToken() + '&ID=' + allFiles[i].ID);
            }
        }

        const r: AddDeleteFilesResponse = {
            success: success,
            returnArray: allFiles
        };

        return r;
    },

    async addDeleteTrainingSearchesFiles(searches: TrainingSearch[]): Promise<AddDeleteFilesResponse>  {
        var success = true;

        for (var i = 0; i < searches.length; i++) {
            let search = searches[i];

            if (search.Documents.length > 0) {
                for (var ii = 0; ii < search.Documents.length; ii++) {
                    if (search.Documents[ii].ID == 0 && search.Documents[ii].File && !search.Documents[ii].IsDeleted) {
                        let uploadFileResponse = await api.postWithFiles<any>('File/UploadFile?userToken=' + CurrentUser.currentUserToken() + '&linkTable=TBL_TrainingSearch&linkTableId=' + search.ID, search.Documents[ii].File);

                        if (uploadFileResponse.ok) {
                            // Re-add files now with an ID
                            search.Documents[ii] = uploadFileResponse.data!;
                        }
                        else {
                            success = false;
                        }
                    }
                    else if (search.Documents[ii].ID != 0 && search.Documents[ii].IsDeleted) {
                        await api.delete('File/DeleteFile?userToken=' + CurrentUser.currentUserToken() + '&ID=' + search.Documents[ii].ID);
                    }
                }
            }
        }

        const r: AddDeleteFilesResponse = {
            success: success,
            returnArray: searches
        };

        return r;
    }

}